import * as React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DateTimePicker } from "@mui/x-date-pickers";

interface FormDateTimePickerProps {
    name: string,
    control: any,
    props: { disabled?: boolean, label: string, minDate?: Date, maxDate?: Date, width?: string }
}

export const FormDateTimePicker = ({ name, control, props }: FormDateTimePickerProps) => {

    const { t } = useTranslation('finance');

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                <DateTimePicker
                    {...props}
                    value={value || null}
                    onChange={onChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            error={!!error}
                            helperText={(error && error.type === 'required' && t('forms.required-field', { label: props.label })) || error?.message}
                        />
                    )}
                    inputFormat="DD/MM/YYYY HH:mm" // Formato della data e dell'ora
                />
            )}
        />
    );
}

export default FormDateTimePicker;
